AOS.init({
  easing: 'ease-in-out',
  once: true
});

window.addEventListener('load', function() {
  AOS.refresh();
}); 

//IE Polyfill for support for 'forEach'
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    var i;
    thisArg = thisArg || window;
    for (i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);
let revealContainers = document.querySelectorAll(".reveal");

const dur = 1.8;
revealContainers.forEach((container) => {
  let imgReveal = container.querySelector(".img-reveal");
  let image = container.querySelector(".img-reveal img");
  let stack = container.querySelector(".stack > div");
  let copy = container.querySelector("p");
  let subHeading = container.querySelector("h3");
  let revealImg = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      toggleActions: "play none none none",
    },
  });

  revealImg
    .set(imgReveal, { autoAlpha: 1 })
    .from(imgReveal, 1.5, {})
    .from(image, 1.5, {
      scale: 1.04,
      delay: -1.5,
      ease: Power2.out,
    })
    .from(
      subHeading,
      {
        duration: dur,
        ease: "back.out(1)",
        stagger: dur,
        x: -30,
        autoAlpha: 0,
      },
      "-=1.3"
    )
    .fromTo(
      stack,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: dur,
        ease: "power2.out",
      },
      "-=1.9"
    )
    .fromTo(
      copy,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: dur,
        ease: "power2.out",
      },
      "-=2"
    );
});
